import { render, staticRenderFns } from "./SubcontractGoodReceiptSuggestionDetailInput.vue?vue&type=template&id=47b0eaad&scoped=true&"
import script from "./SubcontractGoodReceiptSuggestionDetailInput.vue?vue&type=script&lang=js&"
export * from "./SubcontractGoodReceiptSuggestionDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./SubcontractGoodReceiptSuggestionDetailInput.vue?vue&type=style&index=0&id=47b0eaad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b0eaad",
  null
  
)

export default component.exports